export default __webpack_public_path__ + "3fedabe0bdf563d3135b5b6cbcafb95c.jpg";